import { render, staticRenderFns } from "./XSelectPeriodoFiscal.vue?vue&type=template&id=384ba3a0&"
import script from "./XSelectPeriodoFiscal.vue?vue&type=script&lang=js&"
export * from "./XSelectPeriodoFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports